module.exports = __webpack_public_path__ + "static/media/united-kingdom-flag-round-small.05d99a36.png";